import {Component, Input, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren} from "@angular/core";
import {DetailConfigurationField} from "../../../models/detail-configuration-field";
import {DetailService} from "../../../services/details/detail.service";
import {FormBuilder, FormGroup, NgForm} from "@angular/forms";
import {FormComponent} from "../form/form-component/form.component";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {HelperService} from "../../../services/helperService";
import {DataTableDirective} from "angular-datatables";
import * as CryptoJS from "crypto-js";
import {ENVIRONMENT} from "../../../../environments/environment";
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";


@Component({
    selector: 'tig-assignments-editable',
    templateUrl: './assignments-editable.component.html'
})
export class AssignmentsEditableComponent implements OnInit
{


    @Input()
    OBJ_config_fields: DetailConfigurationField;
    @Input()
    OBJ_parent_form_group: FormGroup = null;
    @Input()
    STR_form_group_name: string;
    OBJ_form: NgForm;
    OBJ_assignment;
    private OBJ_modal_options: ModalOptions = ENVIRONMENT.modal_options;
    public MAP_bs_modal_ref: Map<string, BsModalRef> = new Map<string, BsModalRef>();
    private STR_id: string;
    private BOO_new = false;
    private OBJ_group: FormGroup;

    @ViewChild('OBJ_template_ref', {static:false}) OBJ_template_ref: TemplateRef<any>;
    @ViewChildren(DataTableDirective) OBJ_dt_elements: QueryList<DataTableDirective>;
    public OBJ_dt_options: DataTables.Settings = {};
    public BOO_development = ENVIRONMENT.env === 'development';

    /**
     * Function > constructor
     * @param {DetailService} OBJ_detail_service
     * @param {BsModalService} OBJ_modal_service
     * @param {ToastrService} OBJ_toastr_service
     * @param {TranslateService} OBJ_translate_service
     * @param {HelperService} OBJ_helper_service
     * @param OBJ_form_builder
     */
    constructor(
        private OBJ_detail_service: DetailService,
        private OBJ_modal_service: BsModalService,
        private OBJ_toastr_service: ToastrService,
        private OBJ_translate_service: TranslateService,
        public OBJ_helper_service: HelperService,
        private OBJ_form_builder: FormBuilder,
    ) {} // end function constructor


    /**
     * Function > ngOnInit
     */
    ngOnInit()
    {
        this.fillTableWithData();
        this.OBJ_group = this.OBJ_form_builder.group({});
        if(this.OBJ_parent_form_group)
        {
            this.OBJ_parent_form_group.addControl(this.STR_form_group_name, this.OBJ_group);
        } // end if
    } // end function ngOnInit


    /**
     * Function > fillTableWithData
     */
    fillTableWithData()
    {

        if (this.OBJ_config_fields.listing.columns)
        {

            // get config for listing
            let OBJ_config_listing = this.OBJ_config_fields.listing;

            // add renderer to each column
            this.OBJ_helper_service.addRenderer(this.OBJ_config_fields.listing.columns);

            /**
             * @see https://datatables.net/reference/option/dom
             *
             * frti Results in:
             * {filter}
             * {processing}
             * {table}
             * {information}
             *
             * Default: lfrtip
             */
            this.OBJ_dt_options = {
                data: this.getData(),
                columns: OBJ_config_listing.columns,
                searching: OBJ_config_listing.searchable ? OBJ_config_listing.searchable : false,
                lengthChange: false,
                ordering: true,
                order: OBJ_config_listing.order ? OBJ_config_listing.order : [],
                pageLength: 100,
                language: {
                    url: "assets/i18n/datatables/" + this.OBJ_translate_service.currentLang + ".json"
                },
                responsive: true,
                dom: 'frti',
                // dom: 't',
                rowCallback: (OBJ_row: Node, OBJ_data: object, INT_index: number) =>
                {
                    // is also called when sorting
                },
                createdRow: (OBJ_row: Node, OBJ_data: object, INT_index: number) =>
                {
                    $(OBJ_row).on('click', (OBJ_event) =>
                    {
                        let STR_id = CryptoJS.MD5(JSON.stringify(OBJ_data['original'])).toString();
                        this.openModal(this.OBJ_template_ref, this.OBJ_config_fields.name, STR_id, OBJ_data['original']);
                    });
                }
            };

        } // end if

    } // end function fillTableWithData


	/**
	 * Function > getData
	 * @return {Array<any>}
	 */
	getData()
    {

        let ARR_data: Array<any> = [];
        if (this.OBJ_config_fields.value instanceof Array)
        {

            for (let OBJ_item of this.OBJ_config_fields.value)
            {
                ARR_data.push(AssignmentsEditableComponent.enhanceObject(OBJ_item));
            } // end for

        } // end if

        return ARR_data;

    } // end function getData


    /**
     * Function > enhanceObject
     *
     * @param {object} OBJ_item
     * @return {object}
     */
    private static enhanceObject(OBJ_item): object
    {

        let OBJ_entry = {
            [OBJ_item.title]: OBJ_item.loaded_assignments?OBJ_item.loaded_assignments[0].title:null,
            id: OBJ_item.ids[0],
            value: OBJ_item.value,
            original: OBJ_item
        };

        if (OBJ_item.assignments && OBJ_item.assignments.length > 0)
        {

            for (let OBJ_assignment of OBJ_item.assignments)
            {

                if (OBJ_assignment.loaded_assignments && OBJ_assignment.loaded_assignments.length > 0)
                {
                    OBJ_entry[OBJ_assignment.title] = OBJ_assignment.loaded_assignments[0].title;
                }
                else
                {
                    OBJ_entry[OBJ_assignment.title] = (OBJ_assignment.ids.length > 0) ? OBJ_assignment.ids[0] : null;
                } // end if

            } // end for

        } // end if

        // console.log('enhanceObject',OBJ_entry);
        return OBJ_entry;

    } // end function enhanceObject


    /**
     * Function > openModal
     * @param {TemplateRef<any>} OBJ_template_ref
     * @return {void}
     */
    createNew(OBJ_template_ref: TemplateRef<any>): void
    {

        // new object
        this.BOO_new = true;

        // open modal
        this.openModal(OBJ_template_ref, this.OBJ_config_fields.name, null, this.OBJ_config_fields.object_structure);

    } // end function openModal

    /**
     * Function > openModal
     * @param {TemplateRef<any>} OBJ_template_ref
     * @param {string} STR_name
     * @param {string} STR_id
     * @param {object} OBJ_assignment
     * @return {void}
     */
    openModal(OBJ_template_ref: TemplateRef<any>, STR_name: string, STR_id: string=null, OBJ_assignment: object=null): void
    {

        this.BOO_new = false;
        this.STR_id = STR_id;
        if (OBJ_assignment !== null)
        {
            // deep clone the value - otherwise a change in the modal would immediately reflect in the json data which will be sent to the backend
            this.OBJ_assignment = $.extend(true, {}, OBJ_assignment);
        } // end if

        this.MAP_bs_modal_ref.set(
            STR_name,
            this.OBJ_modal_service.show(OBJ_template_ref, this.OBJ_modal_options)
        );

    } // end function openModal


    /**
     * Function > hideModal
     * @param {string} STR_type
     * @return {void}
     */
    hideModal(STR_type = this.OBJ_config_fields.name): void
    {
        this.MAP_bs_modal_ref.get(STR_type).hide();
    } // end function hideModal


    /**
     * Function > applyAssignment
     * @param {FormComponent} OBJ_form_component
     */
    applyAssignment(OBJ_form_component): void
    {

        if (OBJ_form_component.isInvalid())
        {
            this.OBJ_toastr_service.error(this.OBJ_translate_service.instant('oError.sInvalidFields'));
        }
        else
        {

            // set value
            let ARR_data = this.OBJ_config_fields.value;
            if (typeof ARR_data === 'undefined' || ARR_data === null)
            {
                ARR_data = [];
                this.OBJ_config_fields.value = [];
            } // end if

            if (this.STR_id === null)
            {
                ARR_data.push(this.OBJ_assignment);
            }
            else
            {

                // get index of item
                let INT_idx = ARR_data.findIndex((OBJ_item) => {
                        return CryptoJS.MD5(JSON.stringify(OBJ_item)).toString() === this.STR_id;
                    });

                this.OBJ_assignment.loaded_assignments = null;
                if (this.OBJ_assignment.assignments && this.OBJ_assignment.assignments.length > 0)
                {
                    this.OBJ_assignment.assignments[0].loaded_assignments = null;
                } // end if
                ARR_data[INT_idx] = this.OBJ_assignment;

            } // end if

            // update values for view
            this.OBJ_config_fields.value = ARR_data;

            // Mark as edited by user to prevent lossing unsaved data on navigation
            this.OBJ_group.markAsDirty();
            this.OBJ_group.markAsTouched();

            // hide modal
            this.hideModal(this.OBJ_config_fields.name);

            // rerender datatable
            this.rerenderDataTable();

        } // end if

    } // end function applyAssignment

    /**
     * Function > removeAssignment
     * @desc {string} STR_id
     * @return {void}
     */
    removeAssignment(STR_id): void
    {

        // get array with objects
        let ARR_data = this.OBJ_config_fields.value;

        // remove object
        let INT_idx = ARR_data.findIndex(OBJ_data => CryptoJS.MD5(JSON.stringify(OBJ_data)).toString() === STR_id);
        ARR_data.splice(INT_idx, 1);

        // hide modal
        this.MAP_bs_modal_ref.forEach((OBJ_bs_modal_ref: BsModalRef, STR_key: string) => {
            OBJ_bs_modal_ref.hide();
            this.MAP_bs_modal_ref.delete(STR_key);
        });
        this.OBJ_modal_service.hide(1);

        // Mark as edited by user to prevent lossing unsaved data on navigation
        this.OBJ_group.markAsDirty();
        this.OBJ_group.markAsTouched();

        // rerender datatable
        this.rerenderDataTable();

    } // end function removeAssignment


    /**
     * Function > rerenderDataTable
     */
    rerenderDataTable(): void
    {

        this.OBJ_dt_elements.forEach((OBJ_dt_element: DataTableDirective) => {
            if ((OBJ_dt_element as any).el.nativeElement.id === 'tig-dt-element-assignments-' + this.OBJ_config_fields.name.toLowerCase()) {
                OBJ_dt_element.dtInstance.then((OBJ_dt_instance: DataTables.Api) => {
                    OBJ_dt_instance.clear().draw();
                    let ARR_data = this.getData();
                    OBJ_dt_instance.rows.add(ARR_data);
                    OBJ_dt_instance.columns.adjust().draw();
                });
            } // end if
        });

    } // end function rerenderDataTable


} // end class AssignmentsEditableComponent
